var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTouchCursorPoint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.25 11.6h-.00153c-.01447-1.33768-1.31731-3.41344-1.72356-4.02776-.39718-.59747-1.75891-2.57224-2.51929-2.57224s-2.1221 1.97477-2.53062 2.58238c-.40523.60273-1.70223 2.67945-1.723 4.01762h-.002l.0006.02462-.00049.0085h.00071a4.32523 4.32523 0 0 0 4.24918 4.36688 4.32575 4.32575 0 0 0 4.24945-4.377h.00039l-.00028-.00448zm-4.25 2.79583a2.75081 2.75081 0 1 1 2.68421-2.75 2.7177 2.7177 0 0 1 -2.68421 2.75z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.01337 5.23242a6.4677 6.4677 0 0 1 .71655-.7005 2 2 0 1 1 2.54669-.00537 6.37772 6.37772 0 0 1 .72077.697 3.00043 3.00043 0 1 0 -3.984.00885z",
    opacity: 0.55
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 3,
    r: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTouchCursorPoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/touch-cursor-point.062facbe86a225439c921687506c1c03.svg";